import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmail } from 'validator'
import ReCAPTCHA from 'react-google-recaptcha';

import Auth from 'components/Auth'

import Alert from 'components/Alert'
import Field from 'components/Form/Field'
import Label from 'components/Form/Label'
import Input from 'components/Form/Input'
import Button from 'components/Button'
import { Row } from 'components/Layout'
import { BackArrow, Loading } from 'components/Icons'

// routing stuff
import { Link } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { resetPassword } from 'store/reducers/auth.thunks'
import HandleUtils from '../../services/handleUtils'
import { captchaActive, captchakey } from '../../config'
import { SelectUserType } from 'components/Form/Select/SelectUserType'
import { useRef } from 'react'
import { cpf } from "cpf-cnpj-validator";
import { checkCnpjIsValid } from 'utils/helpers';

function LoginPinCode() {
  const { t } = useTranslation()
  const { geral = {} } = useSelector((store) => store)
  const { portalUserTypes } = geral.portalConfig
  const reduxDispatch = useDispatch()

  const [error, setError] = React.useState(false)
  const [login, setLogin] = React.useState("")

  const [captchaValue, setCaptchaValue] = React.useState('')
  const recaptchaRef = useRef(null)

  const [serviceMessage, setServiceMessage] = React.useState(null)
  const [sending, setSending] = React.useState(false);
  const useDocument =  geral.portalConfig.portalAuthType === 'AUTH_REGISTRATION_DOCUMENT'
  const useDocumentOrEmail = geral.portalConfig.portalAuthType === 'AUTH_REGISTRATION_EMAIL_DOCUMENT' 
  const [portalUser, setPortalUser] = React.useState({ label: t('signup.label.PERSON'), value: 'PERSON' })

  function submitForm() {
    if (!login || 
          (login.includes('@') && !useDocument ? !isEmail(login) : 
          (login.length < 14 ? !cpf.isValid(login) : !checkCnpjIsValid(login)) || (login.includes('.') || login.includes('-') || login.includes('/'))
    )) {
      setError(true)
      return
    }
    setError(false)
    setSending(true);
    setServiceMessage(null);
    reduxDispatch(resetPassword(geral.language, login, portalUser.value, callbackSuccess, callbackError, captchaValue))
  }

  function onChange({ target }) {
    setLogin(target.value)
    setError(false);
    setServiceMessage(null);
  }

  function callbackSuccess(userInfo) {
    const emailHatched = HandleUtils.generateEmailHatched(userInfo?.email)
    setLogin('');
    setError(false);
    setSending(false);
    setServiceMessage({
      type: "success",
      message: t('recoveryPassword.service.success', { email: emailHatched })
    });

  }

  function callbackError(error) {
    setSending(false);
    setServiceMessage({
      type: "error",
      message: t('recoveryPassword.service.error')
    })
    setCaptchaValue('')
    recaptchaRef?.current?.reset()
  }

  const handlePortalUser = (vl) => {
    setPortalUser(vl)
  }

  return (
    <section>
      <header className="pvt-content-header custom">
        <h1 className="pvt-content-title custom">{t('recoveryPassword.title')}</h1>
      </header>
      <Auth>
        <Field>
          <Row position={['y-center', 'x-start']}>
            <Link className="pvt-backbutton custom" to="/signin">
              <BackArrow />
              <span>{t('button.label.back')}</span>
            </Link>
          </Row>
        </Field>

        <Field>
          <Alert
            align="center"
            size="full"
            text={
              <>
                <b>
                  <b>{useDocumentOrEmail ? t('recoveryPassword.alert.typeYourEmailOrDocument'):
                  useDocument ? t('recoveryPassword.alert.typeYourDocument')
                    : t('recoveryPassword.alert.typeYourEmail')}</b>
                </b>
              </>
            }
          />
        </Field>

        {serviceMessage && (
          <Field>
            <Alert
              align="left"
              size="full"
              type={serviceMessage.type}
              text={
                <>
                  {serviceMessage.message}
                </>
              }
            />
          </Field>
        )}

        {sending ?
          <p><Loading /></p>
          :
          <>
            {portalUserTypes?.length > 1 &&
              <Field>
                <Label label={t('signup.label.i.am')} mandatory={true} />
                <SelectUserType onChange={handlePortalUser} value={portalUser} />
              </Field>
            }
            <Field>
              <Label label={useDocumentOrEmail ? t('recoveryPassword.label.typeYourEmailOrDocument'): 
              useDocument ? t('recoveryPassword.label.typeYourDocument')
                : t('recoveryPassword.label.typeYourEmail')} relation="password-field" />
              <Input value={login} name="login" id="login" type="text" required
                onChange={onChange}
                invalidMessage={error ? t('recoveryPassword.validation.error.submit') : null} />
            </Field>
            {captchaActive &&
              <Field>
                <ReCAPTCHA ref={recaptchaRef} sitekey={captchakey} onChange={(value) => setCaptchaValue(value)} />
              </Field>
            }
            <Field>
              <Button
                onClick={submitForm}
                type="confirm"
                label={t('button.label.send')}
                classie="full"
                disabled={(captchaActive ? !captchaValue : false) || (!portalUser?.value && portalUserTypes?.length > 1)} />
            </Field>
          </>
        }
      </Auth>
    </section>
  )
}

export default LoginPinCode
